import React from 'react';
import { PublicFooter } from './PublicLayout';
export default function Footer() { return <PublicFooter />; }
